<template>
    <div>
        <b-button
            variant="warning"
            @click.stop="mostrarModal = true"
            class="float-right"
            :disabled="valorDisponivel == 0"
        >
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Dotação Orçamentária
            </span>
        </b-button>
        <inserir-atualizar-dotacao-form
            acao="INSERIR"
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :valorTotal="valorTotal"
            :valorDisponivel="valorDisponivel"
            @inserirRateio="$emit('inserirRateio', $event)"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        ></inserir-atualizar-dotacao-form>
    </div>
</template>

<script>
import InserirAtualizarDotacaoForm from './InserirAtualizarDotacaoForm'

export default {
    props: {
        valorTotal: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        },

        acao: {
            type: String,   
            default: () => null
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    mounted() {
        if (this.acao == "Inserir") {
            this.mostrarModal = true       
        }
    },  

    components: {
        InserirAtualizarDotacaoForm
    }
}
</script>